import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { EmailService } from '@app/services/email.service';
import { of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css'],
})
export class EmailComponent implements OnInit {
  emails: any[];
  allMail: any;
  selectedMail: any;
  filteredEmails: any = { contents: [] };
  fullEmailBody = '';
  isloading = false;
  isPopupOpen = false;
  searchTerm = '';
  isSidebarExpanded = true;
  sanitizedEmailBody: SafeHtml = '';
  findBox = 'sent'
  searchQuery = '';
  isPopupVisible = false;
  isCcVisible = false;
  isBccVisible = false;
  isSending = false; 
  isDropdownVisible = false; 
 
  constructor(private emailService: EmailService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.getEmails('sent');
  }

  getEmails(filter: any): void {
    this.emailService
      .getEmails()
      .pipe(
        catchError((error) => {
          console.log(error);
          return of([]);
        }),
        finalize(() => { }),
      )
      .subscribe((data) => {
        const sortedEmails = data.sort((a, b) => new Date(b.modified_on).getTime() - new Date(a.modified_on).getTime());
        this.allMail = sortedEmails;
        this.emails = this.allMail.filter((i) => i.status === filter);
        this.filteredEmails = this.emails;
        this.setupFilteredEmails();
      });
  }

  filterEmails(folder: any): void {
    this.findBox = folder;
    this.emails = this.allMail.filter((i: { status: any }) => i.status === folder);
    this.setupFilteredEmails();
  }

  searchQueryEmails(): void {
    const query = this.searchTerm.trim().toLowerCase();
    if (!query) {
      this.emails = this.allMail.filter((i: { status: string; }) => i.status === this.findBox);
      this.setupFilteredEmails();
      return;
    }

    const filtered = this.allMail.filter((email: { id: any; receiver_emails: any; }) => {
      const emailId = email.id ? String(email.id).toLowerCase() : '';
      const receiverEmails = email.receiver_emails ? String(email.receiver_emails).toLowerCase() : '';
      return emailId.includes(query) || receiverEmails.includes(query);
    });

    this.emails = filtered.filter((i: { status: string }) => i.status === this.findBox);
    this.setupFilteredEmails();
  }

  setupFilteredEmails(): void {
    const stripHtml = (html: string): string => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const textContent = doc.body.textContent || '';
      const words = textContent.split(/\s+/);

      const screenWidth = window.innerWidth;
      let sliceLength = 35;

      if (screenWidth < 576) {
        sliceLength = 15;
      } else if (screenWidth >= 576 && screenWidth < 768) {
        sliceLength = 20;
      } else if (screenWidth >= 768 && screenWidth < 992) {
        sliceLength = 25;
      } else if (screenWidth >= 992 && screenWidth < 1200) {
        sliceLength = 30;
      }

      return words.length > sliceLength ? words.slice(0, sliceLength).join(' ') + '...' : textContent;
    };

    this.filteredEmails = {
      headers: ['ID', 'Receiver Emails', 'Body Text', 'Status', 'Send date & time'],
      contents: this.emails.map((i) => ({
        ID: i.id,
        'Receiver Emails': i.receiver_emails,
        'Body Text': stripHtml(i.body_text),
        Status: i.status,
        'Send date & time': this.formatDate(i.modified_on),
      })),
    };
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();

    // Helper function to check if two dates are the same day
    const isSameDay = (d1: Date, d2: Date): boolean =>
      d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();

    // Helper function to check if the date is yesterday
    const isYesterday = (d: Date): boolean => {
      const yesterday = new Date(now);
      yesterday.setDate(now.getDate() - 1);
      return isSameDay(d, yesterday);
    };

    // Check if the date is today
    if (isSameDay(date, now)) {
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`; // Show only time for today
    }

    // Check if the date is yesterday
    if (isYesterday(date)) {
      return `Yesterday`; // Show "Yesterday"
    }

    // For other dates, show mm-dd-yyyy
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    // Return formatted date as mm-dd-yyyy
    return `${month}-${day}-${year}`;
  }

  toggleSelectAll(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.filteredEmails.contents.forEach((email: { selected: boolean }) => (email.selected = checked));
  }

  emailClick(email: any): void {
    if (!email) {
      console.error('No email selected');
      return;
    }
    console.log(email.ID);
    this.isPopupOpen = true;
    const selectedMail = this.allMail.filter((i: { id: any }) => i.id === email.ID);
    this.selectedMail = selectedMail[0];
    const emailBody = this.selectedMail.body_text;
    console.log(selectedMail[0]);
    this.sanitizedEmailBody = this.sanitizeAndModifyLinks(emailBody);
  }
  sanitizeAndModifyLinks(html: string): SafeHtml {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Optionally, modify links or add additional attributes
    const links = doc.querySelectorAll('a');
    links.forEach((link) => {
      link.setAttribute('target', '_blank'); // Open links in a new tab
    });

    // Sanitize the modified HTML
    const modifiedHtml = doc.body.innerHTML;
    return this.sanitizer.bypassSecurityTrustHtml(modifiedHtml);
  }

  close() {
    this.isPopupOpen = false;
  }
   isToday(dateString: string): boolean {
    const date = new Date(dateString);
    const today = new Date();
    return date.toDateString() === today.toDateString(); // Checks if it's today
  }

  isYesterday(dateString: string): boolean {
    const date = new Date(dateString);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1); // Move back 1 day
    return date.toDateString() === yesterday.toDateString(); // Checks if it's yesterday
  }
  togglePopup() {
    this.isPopupVisible = !this.isPopupVisible;
  }
  toggleCc(): void {
    this.isCcVisible = !this.isCcVisible;
  }

  
  toggleBcc(): void {
    this.isBccVisible = !this.isBccVisible;
  }

  
  sendEmail(): void {
    this.isSending = true;
    setTimeout(() => {
      this.isSending = false;
      
    }, 2000);
  }

  
  toggleDropdown(): void {
    this.isDropdownVisible = !this.isDropdownVisible;
  }

 
  onDropdownOption(option: string): void {
    this.isDropdownVisible = false; 
    alert(`Selected: ${option}`);
  }

 
  triggerFileInput(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const selectedFile = input.files[0];
      console.log('Selected file:', selectedFile.name);
      } else {
      console.log('No file selected');
    }
  }
}